<div class="w-100 h-100 justify-content-center">
  <div class="viewer-container h-100">
    <app-pdf-viewer [document]="document"></app-pdf-viewer>
  </div>
</div>
